var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.valuation)?_c('Valuation',{attrs:{"valuation":_vm.valuation,"lead-data":_vm.valuation.lead,"user":_vm.valuation.user}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }